export const SPEAKER_SEGMENT_SPACING_MULTIPLIER = 1;
export const SPEAKER_SEGMENT_TOP_SPACING_MULTIPLIER = 5;
